var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "occupation-interments" },
    _vm._l(_vm.interments, function (interment, idx) {
      return _c("OccupationIntermentItem", {
        key: `interment-${idx}`,
        staticClass: "interment",
        attrs: {
          value: interment,
          indexItem: idx,
          panelCfg: _vm.panelCfg,
          moduleCode: _vm.moduleCode,
          additional: _vm.additional,
          baseTranslateID: _vm.baseTranslateID,
        },
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }